import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { removeInventoryItem } from "../redux-state/features/inventory/inventorySlice";
const ItemsTable = ({}) => {
  const dispatch = useDispatch();
  const items = useSelector((state) => state.inventoryState.newItems);
  // Handle new item addition
  const handleNewItem = (newItem) => {
    // setItems([...items, newItem]);
  };

  // Handle item deletion
  const handleDeleteItem = (inventoryCode) => {
    // setItems(items.filter((item) => item.id !== id));
    dispatch(removeInventoryItem({ inventoryCode }));
  };

  return (
    <div className="container mt-4">
      {/* Table to display items */}
      <div className="mt-5">
        <table className="table  ">
          <thead className="table-light text-center">
            <tr>
              <th>رقم الجرد</th>
              <th>اسم المادة</th>
              {/* <th>مكان استغلالها</th> */}
              <th style={{ width: "10%" }}>حذف</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, idx) => (
              <tr className="text-center" key={"inventory" + idx}>
                <td>{item.inventoryCode}</td>
                <td>{item.itemName}</td>
                {/* <td>{item.itemUsePlace}</td> */}
                <td className="">
                  <button
                    className="btn    border border-1 text-danger"
                    onClick={() => handleDeleteItem(item.inventoryCode)}
                  >
                    <FontAwesomeIcon icon={faTrashCan} className="mx-3" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ItemsTable;
